import Headroom from "react-headroom";
import {css, cx} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

interface WrapperProps {
    children: React.ReactNode;
    ref?: React.Ref<HTMLDivElement>;
}

export const Wrapper = ({children, ref}: WrapperProps) => {
    const {isMobile} = useUserDevice();

    if (isMobile) {
        return (
            <div ref={ref}>
                <Headroom disableInlineStyles pinStart={navigationHeight} className={stickySearchHeadroomStyle}>
                    {children}
                </Headroom>
            </div>
        );
    }

    return <div ref={ref}>{children}</div>;
};

interface WideContentStyledProps {
    isInvestment?: boolean;
    children: React.ReactNode;
}

export const WideContentStyled = ({isInvestment, children}: WideContentStyledProps) => {
    return <WideContent className={cx(wideContentBaseStyle, isInvestment && wideContentInvestmentStyle)}>{children}</WideContent>;
};

const wideContentBaseStyle = css({
    pt: 1.5,
    pb: 1.5,
    transition: "top 200ms ease-in-out",
    boxShadow: "var(--shadow-4)",
    backgroundColor: "var(--colors-white)",
    position: "relative",
    width: "100%",
    marginLeft: "initial",
    marginRight: "initial",
    maxWidth: "initial",

    md: {
        backgroundColor: "initial",
        boxShadow: "var(--shadow-0)",
        maxWidth: "var(--grid-md-widthPx)",
        marginLeft: "auto",
        marginRight: "auto",
        position: "initial"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)"
    }
});

const wideContentInvestmentStyle = css({
    md: {
        marginBottom: 0,
        paddingBottom: 0
    }
});

const stickySearchHeadroomStyle = css({
    "& .headroom": {
        position: "fixed",
        top: "-100vh",
        left: 0,
        right: 0,
        zIndex: 22,
        transition: "top 200ms ease-in-out"
    },
    "& .headroom--unfixed": {
        position: "relative",
        top: 0,
        transition: "none"
    },
    "& .headroom--pinned": {
        top: 0
    },
    "& .headroom--unpinned": {
        top: "-100vh"
    }
});
import Headroom from "react-headroom";
import {css, cx} from "@panda/css";

import {WideContent} from "@pg-design/grid-module";
import {useUserDevice} from "@pg-mono/user-device";
import {navigationHeight} from "@pg-rp/navigation";

interface WrapperProps {
    children: React.ReactNode;
    ref?: React.Ref<HTMLDivElement>;
}

export const Wrapper = ({children, ref}: WrapperProps) => {
    const {isMobile} = useUserDevice();

    if (isMobile) {
        return (
            <div ref={ref}>
                <Headroom disableInlineStyles pinStart={navigationHeight} className={stickySearchHeadroomStyle}>
                    {children}
                </Headroom>
            </div>
        );
    }

    return <div ref={ref}>{children}</div>;
};

interface WideContentStyledProps {
    isInvestment?: boolean;
    children: React.ReactNode;
}

export const WideContentStyled = ({isInvestment, children}: WideContentStyledProps) => {
    return <WideContent className={cx(wideContentBaseStyle, isInvestment && wideContentInvestmentStyle)}>{children}</WideContent>;
};

const wideContentBaseStyle = css({
    pt: 1.5,
    pb: 1.5,
    transition: "top 200ms ease-in-out",
    boxShadow: "var(--shadow-4)",
    backgroundColor: "var(--colors-white)",
    position: "relative",
    width: "100%",
    marginLeft: "initial",
    marginRight: "initial",
    maxWidth: "initial",

    md: {
        backgroundColor: "initial",
        boxShadow: "var(--shadow-0)",
        maxWidth: "var(--grid-md-widthPx)",
        marginLeft: "auto",
        marginRight: "auto",
        position: "initial"
    },

    lg: {
        maxWidth: "var(--grid-lg-widthPx)"
    }
});

const wideContentInvestmentStyle = css({
    md: {
        marginBottom: 0,
        paddingBottom: 0
    }
});

const stickySearchHeadroomStyle = css({
    "& .headroom": {
        position: "fixed",
        top: "-100vh",
        left: 0,
        right: 0,
        zIndex: 22,
        transition: "top 200ms ease-in-out"
    },
    "& .headroom--unfixed": {
        position: "relative",
        top: 0,
        transition: "none"
    },
    "& .headroom--pinned": {
        top: 0
    },
    "& .headroom--unpinned": {
        top: "-100vh"
    }
});
